import { render, staticRenderFns } from "./UgcContents.vue?vue&type=template&id=5968da7c&"
import script from "./UgcContents.vue?vue&type=script&lang=ts&"
export * from "./UgcContents.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports